/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.size : set the icon size, see getSize for expected values
 * @param props.className : a tailwind class the would be implemented on span tag
 */

interface PersonProps {
  color?: string
  size?: string
  className?: string
}

const IconDown = (props: PersonProps) => {
  const { className = '', color = '#364152' } = props
  return (
    <span className={'flex items-center justify-center ' + className}>
      <svg
        width={20}
        height={20}
        viewBox="0 -5 8 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.2002 1.40156L4.0002 4.60156L0.800196 1.40156"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default IconDown
